import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Text
} from '@knockrentals/knock-shared-web';
import { ProductIcon, PropertyIcon } from '../../../../../Components/Icons';
import { NO_PRODUCTS_LABEL, PRODUCTS_LABEL, RESIDENT_KEY } from './constants';

const useStyles = makeStyles(() => ({
  countRow: {
    alignItems: 'center',
    display: 'flex'
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    borderBottom: '1px solid #ddd',
    '& .MuiCardHeader-avatar': {
      marginRight: '8px'
    }
  },
  productItem: {
    padding: '16px',
    '&.Mui-selected': {
      backgroundColor: '#e3f2fd'
    }
  },
  productItemDisabled: {
    padding: '16px',
    opacity: 0.5,
    cursor: 'not-allowed',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& .MuiListItemText-root': {
      color: '#9e9e9e',
    },
    '& .MuiListItemSecondaryAction-root': {
      color: '#9e9e9e',
    },
  },
  productRow: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
  propertyIcon: {
    marginLeft: '8px'
  },
  productSidebar: {
    maxHeight: '75vh'
  }
}));

const ProductSidebar = ({ handleProductSelect, isInternalMode, products, selectedProduct }) => {
  const classes = useStyles();

  return (
    <Card variant="outlined" className={classes.productSidebar}>
      <CardHeader
        avatar={<ProductIcon/>}
        className={classes.header}
        title={<Text variant="subtitle1">{PRODUCTS_LABEL}</Text>}
      />
      <List disablePadding>
        {products.length === 0 ? (
          <ListItem>
            <ListItemText>{NO_PRODUCTS_LABEL}</ListItemText>
          </ListItem>
        ) : (
          products.map((product) => {
            const isItemSelected = selectedProduct === product.key;
            const isResidentProduct = product.key === RESIDENT_KEY;
            const isDisabled = isResidentProduct && !isInternalMode;

            return (
              <ListItem
                aria-selected={isItemSelected}
                button
                className={isDisabled ? classes.productItemDisabled : classes.productItem}
                disabled={isDisabled}
                disableGutters
                key={product.key}
                onClick={() => handleProductSelect(product.key)}
                selected={isItemSelected && !isDisabled}
              >
                <ListItemText>
                  <Text variant="subtitle2">{product.name}</Text>
                </ListItemText>
                <ListItemSecondaryAction className={classes.countRow}>
                  <Text variant="body2">{product.count}</Text>
                  <PropertyIcon className={classes.propertyIcon} />
                </ListItemSecondaryAction>
              </ListItem>
            );
          })
        )}
      </List>
    </Card>
  );
};

ProductSidebar.propTypes = {
  handleProductSelect: PropTypes.func.isRequired,
  isInternalMode: PropTypes.bool.isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.number.isRequired,
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedProduct: PropTypes.string.isRequired
};

export default ProductSidebar;
